<template>

  <div>
    <div class="beneficary-details-page">
      <div class="left">
        <h1>

          {{ this.beneficiary.last_name + " " + this.beneficiary.first_name }}
        </h1>
      </div>
      <div class="right">

      </div>
      <br/>
      <br/>
      <div :class="!this.beneficiary.active && 'benef'">
        <div class="container-alb">
          <table width="95%" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td align="left">
                <small>{{ $t("title.lastNameField") }}</small>
                <br/>
                <input
                  id="beneficiaryLastName"
                  type="text"
                  v-model="formData.lastName"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("title.surnameFieldLabel") }}</small>
                <br/>
                <input
                  type="text"
                  id="beneficiaryFirstName"
                  v-model="formData.firstName"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("title.cnpFieldLabel") }}</small>
                <br/>
                <input
                  type="text"
                  :value="beneficiary.cnp"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
            </tr>
          </table>

        </div>
        <div class="container-alb">
          <table width="95%" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td align="left">
                <h3>{{ $t("title.beneficiaryObservationsTitle") }}</h3>
                <div class="loading" v-if="observationsLoading">
                  <img src="@/assets/images/loading.gif" />
                </div>
                <template v-else>
                  <p class="beneficiary-observations-question">
                    {{ $t("title.beneficiaryProblemResolvedQuestion") }}
                  </p>
                  <label class="beneficiary-observations-option">
                    <input
                      v-model="observationsResolved"
                      type="radio"
                      :value="true"
                      :disabled="!observationsEditMode"
                    />
                    {{ $t("title.yesLabel") }}
                  </label>
                  <label class="beneficiary-observations-option">
                    <input
                      v-model="observationsResolved"
                      type="radio"
                      :value="false"
                      :disabled="!observationsEditMode"
                    />
                    {{ $t("title.noLabel") }}
                  </label>
                  <textarea
                    id="beneficiaryObservations"
                    v-model="observationsData"
                    class="beneficiary-observations-textarea"
                    :disabled="!observationsEditMode"
                    :placeholder="$t('title.beneficiaryObservationsPlaceholder')"
                    aria-required="true"
                  ></textarea>
                </template>
              </td>
            </tr>
          </table>

          <table cellpadding="10" cellspacing="0" width="95%" align="center">
            <tr v-if="!observationsEditMode">
              <td>
                <a
                  class="notification-action custom-notification-action"
                  @click="editBeneficiaryObservations()"
                >
                  {{ $t("title.editButtonLabel") }}
                </a>
              </td>
            </tr>
            <tr v-if="observationsEditMode">
              <td>
                <a
                  class="notification-action"
                  @click="saveBeneficiaryObservations()"
                >
                  {{ $t("title.saveChangesLabel") }}
                </a>
              </td>
              <td>
                <a class="resetButton" @click="resetBeneficiaryObservations()">
                  {{ $t("title.exitWithoutSaveLabel") }}
                </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="loading" v-if="!beneficiaryCore">
          <img src="@/assets/images/loading.gif" />
        </div>
        <div v-else>
          <div class="container-alb">
            <div style="margin-left: 30px;">
              <h3>{{ $t("title.beneficiariesDetailsTitle") }}</h3>
              <p v-if="beneficiaryCore.id > 0"> {{ $t("title.companyNameLabel") + ": " + beneficiaryCore.customer_name }} &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;
                {{ beneficiaryCore.email }} &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp; {{
                  displayDateCreation(beneficiaryCore.creation_date)
                }}</p>
              <p v-else>{{ $t("title.beneficiaryNotFoundLabel") }}</p>
            </div>
          </div>

          <template v-if="beneficiaryCoreAccounts">
            <div
              v-for="(entry, index) in beneficiaryCoreAccounts"

              :key="index"
              class="box-left "
              :class="index % 2 === 1 && 'clear-none'"
            >
              <div class="container-alb">
                <div class="usage-volume-container">
                  <img class="heigth-20"
                       :src="require('@/assets/images/logo-up-' +
                  (entry.product > 1500 ? '15' : entry.product) +
                  '.png')
                  "
                  />
                  <br/>
                  <div v-if="entry.card && entry.card !== null">
                    <div class="grey-card">
                      <p align="center">
                        {{ $t("title.companyNameLabel") + ": " + beneficiaryCore.customer_name }}
                        <br/>
                        {{ $t("title.cardNumberLabel") }}
                        {{ entry.card && entry.card.pan }}
                        <br/>
                        {{ $t("title.beneficiariesTableCardStatus") + ": " }}
                        <span class="status-background" :class="getClassForCardStatus(entry.card.state)">{{
                            $t("title.cardStatus_" + entry.card.state)
                          }}</span>
                        <br/>
                        {{ $t("title.beneficiariesTableCardType") + ": " }}
                        {{
                          entry.card.virtual ? $t('title.beneficiariesTableCardTypeVirtual') : $t('title.beneficiariesTableCardTypePhysical')
                        }}
                        <br/>
                        {{
                          entry.card &&
                          $t("title.cardExpiryLabel") + " " + entry.card.expire
                        }}
                      </p>
                      <div class="text-center">
                        <template v-for="(event, index) in entry.card.events" :key="index">
                          <span class="status-background" :class="getClassForCardStatus(event.type)">{{
                              $t("title.cardStatus_" + event.type)
                            }}</span>
                        </template>
                      </div>
                    </div>
                    <div class="text-center d-flex">
                      <a
                        v-if="entry.card.state === 'active' || entry.card.state === 'created'"
                        class="notification-outline"
                        @click="showModalPopup('modal_popup_confirmBlockCard', true, entry)"

                      >{{ $t("title.blockCardButtonLabel") }}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div id="modal_popup_confirmBlockCard" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="showModalPopup('modal_popup_confirmBlockCard', false)"
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg"/>
        </a>
        <p v-html="$t('title.confirmBlockCardReqMsg')">
        </p>
        <div class="buttons">
          <a href="#" class="yesButton" @click="confirmCardAction(choosenAccount, 'BLOK')">Yes</a>
          <a
            href="#"
            class="noButton"
            @click="showModalPopup('modal_popup_confirmBlockCard', false)"
          >No</a>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="
            refresh ? redirectToSearchPage() : showModalPopup('modal_popup_info', false)
            "
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg"/>
        </a>
        <p
          v-if="this.actionError"
          v-html="$t('title.errorActionBeneficiary_' + this.actionError.code)"
        ></p>
        <p v-if="this.successMessage">{{ this.successMessage }}</p>

        <div v-if="this.actionOrderErrors">
          <p
            v-for="(error, index) in this.actionOrderErrors"
            :key="index"
            class="trhover"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            {{ $t(error.error_code, {name: error.from_source_id}) }}
          </p>
        </div>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif"/>
        <p v-html="$t('title.loadingPopupMessage')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import httpServiceBenef from "@/http/http-ben-support.js";
import httpServiceCustomer from "@/http/http-customer.js";
import utils from "@/plugins/utils.js";
import moment from "moment";
import Cookies from "js-cookie";
import $ from "jquery";
import BeneficiaryAccountsTable from "@/components/company/beneficiaries-support/BeneficiaryAccountsTable.vue";
// import CustomerBeneficiaryDetails from "@/components/company/customer/BeneficiaryDetails.vue";

export default {
  props: {
    beneficiaryId: Number,
    user: Object,
    userRole: String,
  },
  components: {
    BeneficiaryAccountsTable,
  },
  data() {
    return {
      beneficiary: null,
      beneficiaryCore: null,
      beneficiaryCoreAccounts: null,
      actionOrderErrors: null,
      accountLoaded: false,
      historyDetails: null,
      choosenAccount: null,
      beneficiaryDataError: null,
      actionError: null,
      successMessage: null,
      formData: null,
      observationsData: "",
      initialObservationsData: "",
      observationsResolved: null,
      initialObservationsResolved: null,
      observationsEditMode: false,
      observationsLoading: false,
      editMode: false,
      detailsMobile: false,
      selectedHistoryDetails: null,
      search: "",
      sortBy: "date",
      reverse: true,
      refresh: false,
      config: null,
    };
  },
  methods: {
    getBeneficiaryDetails(firstView = false) {
      if (this.beneficiary) {
        this.getBeneficiaryDetailsCore(this.beneficiary.id, firstView)
        this.getBeneficiaryObservations(this.beneficiary.id)
      } else {
        this.beneficiaryCoreAccounts = []
      }
    },
    getBeneficiaryObservations(beneficiaryId) {
      this.observationsLoading = true;
      httpServiceBenef.beneficiariesService
        .getBeneficiaryObservations(
          beneficiaryId,
          this.accessToken
        )
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          if (error.response) {
            return error.response;
          }
          return {status: 500};
        })
        .then((response) => {
          if (response.status === 200) {
            this.observationsData = response.data.details || "";
            this.observationsResolved = typeof response.data.resolved === "boolean"
              ? response.data.resolved
              : null;
          } else if (response.status === 404) {
            this.observationsData = "";
            this.observationsResolved = null;
          } else {
            this.actionError = {code: response.status};
          }

          this.initialObservationsData = this.observationsData;
          this.initialObservationsResolved = this.observationsResolved;
          this.observationsEditMode = false;
          this.observationsLoading = false;
        });
    },
    editBeneficiaryObservations() {
      this.observationsEditMode = true;
    },
    resetBeneficiaryObservations() {
      this.observationsData = this.initialObservationsData;
      this.observationsResolved = this.initialObservationsResolved;
      this.observationsEditMode = false;
    },
    saveBeneficiaryObservations() {
      this.successMessage = null;
      this.actionError = null;
      this.showModalPopup("modal_popup_loading", true);

      if (!this.observationsData.trim() || !this.hasResolvedAnswer) {
        this.successMessage = this.$t("title.beneficiaryObservationsRequiredToSave");
        this.showModalPopup("modal_popup_loading", false);
        this.showModalPopup("modal_popup_info", true);
        return;
      }

      const cardId =
        this.beneficiaryCoreAccounts &&
        this.beneficiaryCoreAccounts.length > 0 &&
        this.beneficiaryCoreAccounts[0].card
          ? this.beneficiaryCoreAccounts[0].card.id
          : null;

      const payload = {
        card_id: cardId,
        activity: "NOTE",
        details: this.observationsData,
        resolved: this.observationsResolved,
      };

      httpServiceBenef.beneficiariesService.createBeneficiaryObservations(
        this.beneficiary.id,
        payload,
        this.accessToken
      )
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          if (error.response) {
            return error.response;
          }
          return {status: 500};
        })
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.observationsData = response.data.details || "";
            this.observationsResolved = typeof response.data.resolved === "boolean"
              ? response.data.resolved
              : this.observationsResolved;
            this.initialObservationsData = this.observationsData;
            this.initialObservationsResolved = this.observationsResolved;
            this.observationsEditMode = false;
            this.actionError = null;
            this.successMessage = this.$t(
              this.observationsResolved
                ? "title.beneficiaryObservationsSaveSuccessResolved"
                : "title.beneficiaryObservationsSaveSuccessUnresolved"
            );
          } else if (response.status === 400) {
            this.actionError = {code: response.data && response.data.error_code ? response.data.error_code : response.status};
          } else {
            this.actionError = {code: response.status};
          }

          this.showModalPopup("modal_popup_loading", false);
          this.showModalPopup("modal_popup_info", true);
        });
    },
    getBeneficiaryDetailsCore(beneficiaryId, firstView = false) {
      httpServiceBenef.beneficiariesService
        .getBeneficiaryDetailsCore(
          beneficiaryId,
          this.accessToken,
          firstView
        )
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          this.showModalPopup("modal_popup_loading", false);
        })
        .then((response) => {
          if (response.status === 200) {
            this.beneficiaryCore = response.data
            this.beneficiaryCoreAccounts = this.beneficiaryCore.accounts;
            this.accountLoaded = true;
          } else if (response.status === 400 || response.status === 403) {
          }
        });
    },
    confirmCardAction(accountEntity, action) {
      this.actionOrderErrors = null;
      this.refresh = false;
      this.successMessage = null;
      let cardsActionData = {
        id: 0,
        type: action,
        customer_id: accountEntity.company_id,
        product: accountEntity.product,
      };
      this.showModalPopup("modal_popup_confirmBlockCard", false);
      this.showModalPopup("modal_popup_loading", true);
      httpServiceBenef.beneficiariesService
        .cardsAction(cardsActionData,
          accountEntity.id,
          accountEntity.card.id,
          this.accessToken,
          this.userRole
        )
        .then(function (response) {
          return response;
        })
        .catch((error) => {
          return error.response;
        })
        .then((response) => {
          if (response.status === 200) {
            this.actionSuccess = true;
            this.actionError = null;
            // this.beneficiaryCoreAccounts = null;
            this.accountLoaded = false;
            this.getBeneficiaryDetailsCore(this.beneficiaryCore.id);
            this.successMessage = this.$t("title.actionSuccessMessage", {
              action: this.$t("title.cardsAction_" + action)
            });
            this.showModalPopup("modal_popup_loading", false);
            // this.refresh = true;
            this.$forceUpdate();
          } else {

            this.getResponseErrors(response);
          }

          this.showModalPopup("modal_popup_info", true);
        })
    },
    displayDateCreation(date) {
      return moment(date, "YYYY-MM-DD-HH.mm.ss.SSSSSS")
        .format("DD/MM/YYYY");
    },
    showModalPopup(elementId, show, entry = null) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
      if (entry) {
        this.choosenAccount = entry;
      }
    },
    getResponseErrors(response) {
      this.actionOrderErrors = null;
      if (response.headers["link"]) {
        let errorsLink = response.headers["link"].split(";")[0];
        errorsLink = errorsLink.replace(">", "");
        errorsLink = errorsLink.replace("<", "");
        if (errorsLink.includes("exceptions_type")) {
          httpServiceCustomer.customerService
            .getOrderErros(errorsLink, this.accessToken)
            .then((response) => {
              if (response.status === 200) {
                this.actionOrderErrors = response.data.errors;
                this.error = {code: "ERROR"};
              }
            })
            .catch((error) => {
              if (error.response.data) {
                this.error = {code: error.response.data.code};
              } else if (error.response.status === 409) {
                this.error = {code: "409"};
              } else {
                this.error = {code: "500"};
              }
            });
        }
      }
      this.showModalPopup("modal_popup_loading", false);
      this.showModalPopup("modal_popup_info", true);
    },
    resetBeneficiaryDetails() {
      this.formData = {
        lastName: this.beneficiary.last_name,
        firstName: this.beneficiary.first_name,
        cnp: this.beneficiary.cnp,
        // mobilePhone: this.beneficiary.mobile_phone,
        // email: this.beneficiary.email
      };
      this.editMode = false;
      $("#beneficiaryFirstName").prop("disabled", true);
      $("#beneficiaryLastName").prop("disabled", true);
      $("#beneficiaryMobilePhone").prop("disabled", true);
      $("#beneficiaryEmail").prop("disabled", true);
    },
    onlyAlphabetCharacters(variable) {
      if (/^[a-zA-Z-]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(/[0-9&\/\\|`#@\[\]\,+=()$~%.'":*!?<>{}]/g, "");
      }
    },
    onlyNumericCharacters(variable) {
      if (/^[0-9]*$/i.test(variable)) {
        return variable;
      } else {
        return variable.replace(
          /[a-zA-Z&\/\\|`#@\[\]\-,+=()$~%.'":*!?<>{}]/g,
          ""
        );
      }
      return variable;
    },
    updateInputCharacters() {
      this.formData.lastName = this.onlyAlphabetCharacters(
        this.formData.lastName
      );
      this.formData.firstName = this.onlyAlphabetCharacters(
        this.formData.firstName
      );
      this.formData.mobilePhone = this.onlyNumericCharacters(
        this.formData.mobilePhone
      );
      this.beneficiary.security_code = this.onlyNumericCharacters(
        this.beneficiary.security_code
      );
      this.$forceUpdate();
    },
    redirectToSearchPage() {
      this.pushRoute('support_beneficiaries_search');
    },
    getClassForCardStatus(status) {
      switch (status) {
        case "A":
          return "background-active";
        case "B":
        case "F":
        case "RC":
          return "background-blocked";
        case "D":
          return "background-deactivated";
        case "C":
        case "X":
        case "RNN":
          return "background-inactive";
        case "J":
        case "L":
          return "background-cancelled";
        case "E":
        case "I":
        case "M":
        case "N":
        case "O":
        case "P":
        case "R":
        case "S":
        case "RN":
        case "RNV":
        case "RNY":
        case "RP":
          return "background-will-expire";
        case "D_APP":
          return "background-deactivated";
        default:
          return "background-active";
      }
    },
    preventClose(event) {
      if (this.mustSaveObservations) {
        event.preventDefault();
        event.returnValue = "";
      }
    },
    blockNavigation() {
      this.actionError = null;
      this.successMessage = this.$t("title.beneficiaryObservationsRequiredToLeave");
      this.showModalPopup("modal_popup_info", true);
    },
    updateNavigationLock() {
      sessionStorage.setItem(
        "beneficiaryObservationsMustSave",
        String(this.mustSaveObservations)
      );
    },
  },
  computed: {
    hasRequiredObservation() {
      return this.observationsData.trim().length > 0;
    },
    hasResolvedAnswer() {
      return typeof this.observationsResolved === "boolean";
    },
    hasUnsavedObservations() {
      return this.observationsData !== this.initialObservationsData ||
        this.observationsResolved !== this.initialObservationsResolved;
    },
    mustSaveObservations() {
      return !this.hasRequiredObservation || !this.hasResolvedAnswer || this.hasUnsavedObservations;
    }
  },
  watch: {
    observationsData() {
      this.updateNavigationLock();
    },
    initialObservationsData() {
      this.updateNavigationLock();
    },
    observationsResolved() {
      this.updateNavigationLock();
    },
    initialObservationsResolved() {
      this.updateNavigationLock();
    }
  },
  created() {
    this.accessToken = Cookies.get("token");
    this.beneficiary = JSON.parse(localStorage.getItem("selected_beneficiary"));
    this.resetBeneficiaryDetails();

    const firstView = this.$route.query.first_view === "true";
    if (firstView) {
      const query = { ...this.$route.query };
      delete query.first_view;

      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query,
      });
    }

    this.getBeneficiaryDetails(firstView);

  },
  mounted() {
    this.config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
    window.addEventListener("beforeunload", this.preventClose);
    window.addEventListener("beneficiary-observations-required", this.blockNavigation);
    this.updateNavigationLock();
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.preventClose);
    window.removeEventListener("beneficiary-observations-required", this.blockNavigation);
    sessionStorage.removeItem("beneficiaryObservationsMustSave");
  },
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
.notification-outline {
  display: block;
  width: 30%;
  padding-left: 55px;
  padding-right: 55px;
  padding-top: 12px;
  height: auto;
  padding-bottom: 12px;
  background: #fff;
  color: #f49400;
  border: 1px solid #f49400;
  font-weight: bold;
  text-decoration: none;
  border-radius: 5px;
  border-bottom: 2px solid #ddd;
  text-transform: uppercase;
  text-align: center;
  margin: 10px auto;
  cursor: pointer;
}

.clear-none {
  clear: none;
}

.beneficary-details-page .custom-notification-action {
  display: inline-block;
  width: auto;
}

.beneficary-details-page .left {
  display: inline-block;
  width: 50%;
}

.beneficary-details-page .right {
  display: inline-block;
  width: 50%;
}

.beneficary-details-page .right .notification-action {
  margin-left: 10px;
}

.resetButton:not([href]):not([tabindex]) {
  text-decoration: underline;
  color: #585858;
  font-style: italic;
  cursor: pointer;
}

.beneficiary-observations-question {
  margin-bottom: 8px;
  font-weight: bold;
}

.beneficiary-observations-option {
  margin-right: 18px;
  cursor: pointer;
}

.beneficiary-observations-option input {
  margin-right: 5px;
}

.benef {
  position: relative;
  z-index: 9;
}

.disabled {
  background-color: #9b9b9b !important;
}

.heigth-20 {
  height: 20px;
}

.grey-card {
  background: #eee;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 20px;
}

.box-left:nth-child(2n) {
  padding-right: 20px;
  padding-left: 0px;
}

@media (max-width: 1003px) {
  .beneficary-details-page {
    width: 95%;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .beneficary-details-page .custom-notification-action {
    display: inline-block;
    width: auto !important;
    padding: 10px;
    background-image: none;
  }

  .notification-outline {
    display: block;
    width: 100%;
    padding: 0px;
    padding-top: 12px;
    height: auto;
    padding-bottom: 12px;
    background: #fff;
    color: #f49400;
    border: 1px solid #f49400;
    text-decoration: none;
    border-radius: 5px;
    border-bottom: 2px solid #ddd;
    text-transform: uppercase;
    text-align: center;
    margin: 10px auto;
  }

  .grey-card .notification-outline {
    width: auto;
    margin: 10px;
    display: inline-block;
    padding: 10px;
  }
}
</style>
